(function () {
    const scriptTag = document.querySelector('script[data-eeg-index]');
    if (!scriptTag) return;

    const mosaicSrc = scriptTag.getAttribute('data-eeg-index-mosaic-src') || '';
    const bestsellersSrc = scriptTag.getAttribute('data-eeg-index-bestsellers-src') || '';

    const canPrefetchAssets = () => {
        if (window.EEGAssetLoader && typeof window.EEGAssetLoader.canPrefetchAssets === 'function') {
            return window.EEGAssetLoader.canPrefetchAssets();
        }
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return true;
        if (connection.saveData) return false;
        if (typeof connection.effectiveType === 'string' && connection.effectiveType.includes('2g')) return false;
        return true;
    };

    const createScriptLoader = ({ src, scriptAttr, prefetchAttr }) => {
        const state = {
            loaded: false,
            loadPromise: null,
            prefetched: false,
        };

        const load = () => {
            if (state.loaded) return Promise.resolve();
            if (state.loadPromise) return state.loadPromise;
            if (!src || !document.body) return Promise.resolve();

            state.loadPromise = new Promise((resolve, reject) => {
                const existing = document.querySelector(`script[${scriptAttr}]`);
                if (existing) {
                    if (existing.getAttribute('data-eeg-loaded') === 'true') {
                        state.loaded = true;
                        resolve();
                        return;
                    }
                    existing.addEventListener('load', () => {
                        state.loaded = true;
                        resolve();
                    }, { once: true });
                    existing.addEventListener('error', () => {
                        state.loadPromise = null;
                        reject(new Error('Index script failed to load.'));
                    }, { once: true });
                    return;
                }

                const script = document.createElement('script');
                script.src = src;
                script.async = true;
                script.setAttribute(scriptAttr, 'true');
                script.onload = () => {
                    script.setAttribute('data-eeg-loaded', 'true');
                    state.loaded = true;
                    resolve();
                };
                script.onerror = () => {
                    state.loadPromise = null;
                    reject(new Error('Index script failed to load.'));
                };
                document.body.appendChild(script);
            });

            return state.loadPromise;
        };

        const prefetch = () => {
            if (state.prefetched || state.loaded) return;
            if (!src || !document.head) return;
            if (!canPrefetchAssets()) return;

            state.prefetched = true;
            if (document.querySelector(`link[${prefetchAttr}]`)) return;

            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.as = 'script';
            link.href = src;
            link.setAttribute(prefetchAttr, 'true');
            document.head.appendChild(link);
        };

        return { state, load, prefetch };
    };

    const initSymbolHistory = () => {
        const section = document.querySelector('.section-eeg-symbol');
        if (!section) return;

        const cards = Array.from(section.querySelectorAll('.eeg-symbol__card'));
        const images = Array.from(section.querySelectorAll('.eeg-symbol__image-item'));
        const length = Math.min(cards.length, images.length);
        if (!length) return;

        let activeIndex = 0;

        const activateIndex = (index) => {
            if (index === activeIndex || index < 0 || index >= length) return;

            cards[activeIndex].classList.remove('is-active');
            images[activeIndex].classList.remove('is-active');

            cards[index].classList.add('is-active');
            images[index].classList.add('is-active');

            activeIndex = index;
        };

        cards.slice(0, length).forEach((card, index) => {
            card.addEventListener('mouseenter', () => activateIndex(index));
            card.addEventListener('click', () => activateIndex(index));
        });
    };

    const initMosaicLoader = () => {
        if (!mosaicSrc) return;
        const items = document.querySelectorAll('.eeg-mosaic__item');
        if (!items.length) return;

        const target = document.querySelector('.eeg-mosaic') || items[0];
        const loader = createScriptLoader({
            src: mosaicSrc,
            scriptAttr: 'data-eeg-index-mosaic',
            prefetchAttr: 'data-eeg-index-mosaic-prefetch',
        });

        const load = () => loader.load().catch(() => {});
        const prefetch = () => loader.prefetch();

        if (target) {
            target.addEventListener('pointerover', prefetch, { passive: true, once: true });
            target.addEventListener('focusin', prefetch, { once: true });
        }

        if ('IntersectionObserver' in window && target) {
            const observer = new IntersectionObserver((entries) => {
                if (!entries[0].isIntersecting) return;
                load();
                observer.disconnect();
            }, { rootMargin: '200px' });
            observer.observe(target);
        } else {
            load();
        }
    };

    const initBestsellersLoader = () => {
        if (!bestsellersSrc) return;
        const section = document.querySelector('[data-bestsellers-section]');
        if (!section) return;

        const loader = createScriptLoader({
            src: bestsellersSrc,
            scriptAttr: 'data-eeg-index-bestsellers',
            prefetchAttr: 'data-eeg-index-bestsellers-prefetch',
        });

        const load = () => loader.load().then(() => {
            if (cleanup) cleanup();
            return true;
        }).catch(() => false);
        const prefetch = () => loader.prefetch();

        let cleanup = null;

        const handleTrigger = (event) => {
            if (loader.state.loaded) return;
            const target = event.target instanceof Element ? event.target : null;
            if (!target) return;
            const trigger = target.closest('[data-slider-prev], [data-slider-next]');
            if (!trigger) return;
            if (event.type === 'keydown') {
                const code = (event.code || '').toUpperCase();
                if (code !== 'SPACE' && code !== 'ENTER') return;
            }
            event.preventDefault();
            event.stopPropagation();
            load().then((loaded) => {
                if (!loaded) return;
                if (trigger.isConnected) {
                    trigger.click();
                }
            });
        };

        const bind = () => {
            section.addEventListener('click', handleTrigger, true);
            section.addEventListener('keydown', handleTrigger, true);
            section.addEventListener('pointerover', prefetch, { passive: true, once: true });
            section.addEventListener('focusin', prefetch, { once: true });
            cleanup = () => {
                section.removeEventListener('click', handleTrigger, true);
                section.removeEventListener('keydown', handleTrigger, true);
                section.removeEventListener('pointerover', prefetch);
                section.removeEventListener('focusin', prefetch);
                cleanup = null;
            };
        };

        bind();

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                if (!entries[0].isIntersecting) return;
                load();
                observer.disconnect();
            }, { rootMargin: '200px' });
            observer.observe(section);
        } else {
            load();
        }
    };

    initSymbolHistory();
    initMosaicLoader();
    initBestsellersLoader();
})();
